module.exports = __webpack_public_path__ + "img/icon1.712056ad.png";